// extracted by mini-css-extract-plugin
module.exports = {"arrows":"MarketRowToggler__arrows___1-zhJ","arrow":"MarketRowToggler__arrow___2_YNQ","top":"MarketRowToggler__top___IrfE2"};